export default function getAnimationEnd() {
  var style = document.createElement('div').style;

  if ('webkitAnimation' in style) {
    return 'webkitAnimationEnd';
  }

  return 'animationend';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/es/Animation/getAnimationEnd.js
// module id = 514
// module chunks = 0